import Spinner from 'components/loading/Spinner';
import { PATH_NAME } from 'configs/pathName';
import Layout from 'containers/Layout';
import AuthGuard from 'guards/AuthGuard';
import FoundNameGuard from 'guards/FoundNameGuard';
import GuestGuard from 'guards/GuestGuard';
import { ChayTramPage } from 'pages/ChayTram';
import TestingResult from 'pages/result/TestingResult';
import { lazy, Suspense } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// dùng export default
const Login = lazy(() => import('pages/login'));
const Intro = lazy(() => import('pages/Intro'));
const TruyenThong = lazy(() => import('pages/TruyenThong'));
const SelectMethod = lazy(() => import('pages/SelectMethod'));
const Result = lazy(() => import('pages/result/Result'));
const NotFound = lazy(() => import('pages/404/NotFound'));
const SelectChayTram = lazy(() => import('pages/SelectMethod/SelectChayTram'));
const SelectTruyenThong = lazy(() =>
  import('pages/SelectMethod/SelectTruyenThong')
);

// dùng export name
const HomePage = lazy(() =>
  import('pages').then((module) => ({ default: module.IndexPage }))
);
const QuestionSwiper = lazy(() =>
  import('pages/questions-swiper').then((module) => ({
    default: module.QuestionSwiperPage,
  }))
);

const routesConfig = [
  {
    element: <Layout />,
    children: [
      {
        element: <FoundNameGuard />,
        children: [
          {
            path: PATH_NAME.SELECT_METHOD,
            element: <SelectMethod />,
            index: true,
          },
          {
            path: PATH_NAME.CHON_CHAY_TRAM,
            element: <SelectChayTram />,
          },
          {
            path: PATH_NAME.CHON_TRUYEN_THONG,
            element: <SelectTruyenThong />,
          },
        ],
      },
      {
        element: <GuestGuard />,
        children: [
          {
            path: PATH_NAME.LOGIN,
            element: <Login />,
            index: true,
          },
          {
            path: PATH_NAME.INTRO,
            element: <Intro />,
            index: true,
          },
        ],
      },
      {
        path: PATH_NAME.ROOT,
        element: <AuthGuard />,
        children: [
          {
            element: <Navigate to={PATH_NAME.SELECT_METHOD} />,
            index: true,
          },
          {
            path: PATH_NAME.CHAY_TRAM,
            element: <QuestionSwiper />,
          },
          {
            path: PATH_NAME.TRUYEN_THONG,
            element: <TruyenThong />,
          },
          {
            path: PATH_NAME.SELECT_METHOD,
            element: <SelectMethod />,
          },
          {
            path: PATH_NAME.RESULT,
            element: <Result />,
          },
        ],
      },
      {
        path: PATH_NAME.LOGIN,
        element: <Login />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

function AppRoutes() {
  // dùng useRoutes dễ thêm tham số children route hơn
  const appRoutes = useRoutes(routesConfig);

  // sử dụng lazy load cho các pages
  return <Suspense fallback={<Spinner />}>{appRoutes}</Suspense>;
}

export default AppRoutes;
